import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usersData: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsers: (state, { payload }) => {
      state.usersData = payload;
    },
  },
});

export const { setUsers } = usersSlice.actions;

export default usersSlice.reducer;
